import React from 'react';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';
import { useLoading } from '../../../commons/Loading';
import { useTranslation } from 'react-i18next';
import { getSignedUrl, getYousignFile } from '../../../lib/fetch/files';
import SupplierAdminAgreementsPresentational from './SupplierAdminAgreementsPresentational';

const SupplierAdminAgreements = (props) => {
  const [t] = useTranslation('CONTRACTS_AREA');
  const [{ newToken, profile = {} } = {}] = useAuth();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  async function handleFileListView(key) {
    showLoading();

    const { data, error } = await getSignedUrl(key, newToken);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    window.open(data.url, '_blank');
  }

  async function handleFileSigned(signingRequestId) {
    showLoading();

    const { data, error, headers } = await getYousignFile(signingRequestId);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }
    hideLoading();

    const file = new Blob([data], { type: headers['content-type'] });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  return (
    <SupplierAdminAgreementsPresentational
      handleFileSigned={handleFileSigned}
      handleFileListView={handleFileListView}
      {...props}
    />
  );
};

export default SupplierAdminAgreements;
